import IBimageHipextensionTerminalStance1 from '@/pages/ReportV2/components/Modals/assets/IBimageHipextensionTerminalStance1.png';
import IBimageHipextensionTerminalStance2 from '@/pages/ReportV2/components/Modals/assets/IBimageHipextensionTerminalStance2.png';
import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import { VerticalSwiper } from '@/components/swiper';

// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

export const HipExtensionTerminalStanceModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageHipextensionTerminalStance1} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  In dynamic walking the leg works like a pendulum. When it is extended to optimal length, it will swing
                  forward after a propulsive push off by ankle plantar flexion. With exception of some adductor activity
                  (which control the path of the swinging leg) this will hardly consume any energy.
                  <br></br>
                  <br></br>
                  Lengthening the leg is a movement pattern which emerges from joint coupling, accomplished by extending
                  the hip first, then the knee and finally the ankle. The sequence of these movements (proximal to
                  distal) is based on a fixed principle which depends on the position in which the muscles can generate
                  a sufficiently large moment relative to the joint to be moved.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center' style={{ height: '100%' }}>
              <div>
                <IonRow class='ion-justify-content-center' style={{ height: '50%', width: '100%' }}>
                  <IonCol className='ion-no-padding' size='11'>
                    <div>
                      <IonImg src={IBimageHipextensionTerminalStance2} />
                    </div>
                  </IonCol>
                </IonRow>
                <IonRow class='ion-align-items-center ion-justify-content-center'>
                  <IonCol size='11'>
                    <div>
                      Without proper hip extension, the knee will probably not extend properly as well. Finally it is
                      not urgent for the ankle to plantar flex, leading to a weak push-off.
                      <br></br>
                      <br></br>
                      As a result the trajectory of the pendulum will shorten, stride length reduces, velocity falls,
                      momentum is lost and balance is likely to decrease.
                    </div>
                  </IonCol>
                </IonRow>
              </div>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
